import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  IconButton,
  Box,
  Stack
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';

function VestiyerConfirmationDialog({
  open,
  vestiyerNumbers = [],
  onClose,
  onConfirm
}) {
  const [showSucces, setShowSucces] = useState(false);
  const numbersString = vestiyerNumbers.join(", ");
  // Dört adet çemberi tanımlayalım. (İhtiyaca göre renk ve boyutları özelleştirin)
  const circles = [
    { size: 192, color: 'transparent', border: '1px solid #F0F1F4' },
    { size: 144, color: 'transparent', border: '1px solid #F0F1F4' },
    { size: 96, color: 'transparent', border: '1px solid #F0F1F4' },
    { size: 64, color: 'rgba(236, 253, 243, 1)' }, // En büyük çember
    { size: 48, color: 'rgba(220, 250, 230, 1)' },
    { size: 32, color: 'rgba(7, 148, 85, 1)' },
    { size: 26, color: 'rgba(7, 148, 85, 1)' }, // En küçük çember
  ];

  const handleConfirm = () => {
    onConfirm()
    setShowSucces(true)
  }

  const handleClose = () => {
    onClose()
    setShowSucces(false)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2, // Köşeleri yuvarlat
          overflow: 'visible', // Taşan öğelerin görünmesi için
        },
      }}
    >
      {/* Sağ üstte kapatma (X) ikonu */}
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 16,
          top: 16,
          color: (theme) => theme.palette.grey[500],
          zIndex: 2,
        }}
      >
        <CloseIcon />
      </IconButton>
      {!showSucces ? <>
        <DialogContent
          sx={{
            pt: 4,
            pb: 0,
            position: 'relative',
            minHeight: '180px',
            zIndex: 1,

          }}
        >
          {/* Sol üstte (ikon + 4 çember) kapsayıcı */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: 80,
              height: 80,
            }}
          >
            {/* Dört çemberi sıralı şekilde render edelim */}
            {circles.map((circle, index) => (
              <Box
                key={index}
                sx={{
                  position: 'absolute',
                  border: circle.border,
                  width: circle.size,
                  height: circle.size,
                  borderRadius: '50%',
                  backgroundColor: circle.color,
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  // En büyük çember arkada, en küçük önde kalacak şekilde zIndex ayarı
                  zIndex: -10,
                }}
              />
            ))}

            {/* Tik ikonu en üstte */}
            <CheckCircleIcon
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontSize: 28,
                color: 'rgba(220, 250, 230, 1)', // Yeşil
                zIndex: circles.length + 1, // Çemberlerden önde olsun
              }}
            />
          </Box>

          {/* Ortadaki metinler */}
          <Box
            sx={{
              zIndex: 2,
              mt: 2,
              textAlign: 'center',
            }}
          >
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: '20px',
                mb: 1,
              }}
            >
              Müşteri Onay İşlemi
            </Typography>

            <Typography
              sx={{
                fontSize: '16px',
                color: 'rgba(68, 68, 68, 1)',
                mb: 2,
              }}
            >
              <strong>{vestiyerNumbers.join(', ')}</strong> Vestiyer numaralı müşteri işlemini onaylıyor musunuz?
            </Typography>
          </Box>
        </DialogContent>
        <Stack
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            padding: '15px',
            flexDirection: 'column',
            display: 'flex'
          }}
        >
          <Button
            variant="contained"
            onClick={handleConfirm}
            fullWidth
            sx={{
              backgroundColor: 'rgba(32, 159, 99, 1)',
              color: '#fff',
              fontWeight: 600,
              textTransform: 'none',
              mb: 2,
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#16a34a',
              },
            }}
          >
            Onayla
          </Button>

          <Button
            variant="outlined"
            onClick={handleClose}
            fullWidth
            sx={{
              color: '#374151',
              borderColor: '#D1D5DB',
              fontWeight: 500,
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#f9fafb',
                borderColor: '#9ca3af',
              },
            }}
          >
            Vazgeç
          </Button>
        </Stack>
      </> : <>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 3
          }}
        >
          <CheckCircleIcon
            sx={{ fontSize: 60, color: "rgba(32, 159, 99, 1)", marginBottom: 2 }}
          />
          <Typography sx={{ textAlign: 'center', color: 'rgba(30, 30, 30, 1)', fontSize: '16px', fontWeight: '400' }}>
            <span style={{ fontWeight: '600' }}>{numbersString}</span>  Vestiyer numaralı müşteri işlemi başarıyla başlatılmıştır. Detayları listeden görüntüleyebilirsiniz.
          </Typography>

        </DialogContent>
      </>}

    </Dialog>
  );
}

export default VestiyerConfirmationDialog;
